import {type LoadingMode, type ModalPage} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {store} from '../../store';
import {getLocaleText} from '../../util/translation';
import {formatCurrencyString} from '../../util/currency';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {$qsAll} from '../../../../@shared/ts/dom';

/**
 * This button is reused by several peachpay payment methods.
 */
export function setupPeachpayButton() {
	store.subscribe(() => {
		renderButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.page(),
			Environment.modalUI.loadingMode(),
		);

		renderButtonLoading(
			Environment.modalUI.loadingMode(),
		);
	});
}

/**
 * Renders the button display state.
 */
function renderButtonDisplay(gatewayId: string, page: ModalPage, loadingMode: LoadingMode) {
	// Show/hide button container
	if (['cod', 'bacs', 'cheque', 'peachpay_purchase_order'].includes(gatewayId) && page === 'payment') {
		$qsAll('.peachpay-integrated-btn-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.peachpay-integrated-btn-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Hide/Show button
	if (loadingMode === 'loading') {
		$qsAll('.peachpay-integrated-btn', $element => {
			$element.classList.add('hide');
		});
	} else {
		$qsAll('.peachpay-integrated-btn', $element => {
			$element.classList.remove('hide');
		});
	}
}

/**
 * Renders the peachpay order button loading state.
 */
function renderButtonLoading(mode: LoadingMode) {
	// Show/hide the external spinner
	if (mode === 'loading') {
		$qsAll('.peachpay-integrated-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.peachpay-integrated-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide the internal spinner
	if (mode === 'processing') {
		$qsAll('.peachpay-integrated-btn-spinner', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.peachpay-integrated-btn-spinner', $element => {
			$element.classList.add('hide');
		});
	}

	// Show/hide processing message
	if (mode === 'processing') {
		$qsAll('.peachpay-integrated-btn > .button-text', $element => {
			$element.innerHTML = getLocaleText('Processing');
		});
	} else {
		$qsAll('.peachpay-integrated-btn > .button-text', $element => {
			$element.innerHTML = `${getLocaleText('Pay')} ${formatCurrencyString(DefaultCart.total())}`;
		});
	}

	// Enable/disable the button
	if (mode === 'finished') {
		$qsAll<HTMLInputElement>('.peachpay-integrated-btn', $element => {
			$element.disabled = false;
		});
	} else {
		$qsAll<HTMLInputElement>('.peachpay-integrated-btn', $element => {
			$element.disabled = true;
		});
	}
}
